import createSvgIcon from '@ixigo/icons/utils/createSvgIcon';
import { Fragment } from 'react';

export const Clock = createSvgIcon(
	// Todo: this icon has fill color issue
	<Fragment>
		<path
			d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
			stroke="#111111"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M12 6V12L16 14"
			stroke="#111111"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</Fragment>,
	'Clock',
);

export default Clock;
